var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticClass:"app-item box-shadow",attrs:{"id":"app-side","name":"side"}}),_c('div',{staticClass:"app-item",attrs:{"id":"app-body"}},[_c('MainTitle'),_c('div',{attrs:{"id":"app-body-main"}},[_c('router-view')],1)],1),_c('Loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }